import {DiscountCodeValidationMessage, DiscountType} from "../api";

const validationMessageTranslations: { message: DiscountCodeValidationMessage, translation: string }[] = [
    {message: DiscountCodeValidationMessage.Ok, translation: `Kod poprawny`},
    {message: DiscountCodeValidationMessage.CodeExpired, translation: "Wprowadzony kod rabatowy wygasł."},
    {message: DiscountCodeValidationMessage.CodeIncorrect, translation: "Wprowadzony kod rabatowy jest niepoprawny"},
    {
        message: DiscountCodeValidationMessage.OrderAmountNotReached,
        translation: "Nie osiągnięto minimalnej kwoty zamówienia."
    },
    {
        message: DiscountCodeValidationMessage.UsageLimitReached,
        translation: "Limit wykorzystań tego kodu został już osiągnięty."
    },
    {
        message: DiscountCodeValidationMessage.CodeNotApplicable,
        translation: "Kod rabatowy nie dotyczy produktów w tym zamówieniu."
    }
];

const discountTypeTranslations: { type: DiscountType, translation: string, sign?: string }[] = [
    {type: DiscountType.BlackFriday, translation: "Black Friday"},
    {type: DiscountType.FreeDelivery, translation: "Darmowa dostawa"},
    {type: DiscountType.Quota, translation: "Kwotowy", sign: "zł"},
    {type: DiscountType.Percent, translation: "Procentowy", sign: "%"}
]

const discountCodeValidationMessageTranslation = (message: DiscountCodeValidationMessage, additionalMessage?: string) =>
    validationMessageTranslations?.find(x => x.message === message)?.translation
        .concat(` ${additionalMessage ?? ""}`);

const discountTypeTranslation = (type: DiscountType) => {
    const discountType = discountTypeTranslations.find(x => x.type === type);
    if (!discountType) return undefined;
    return {
        translation: discountType.translation,
        sign: discountType.sign
    };
};

export default discountCodeValidationMessageTranslation;

export {discountTypeTranslation};
